import { createSelector, createSlice } from '@reduxjs/toolkit';
import { getDuration } from '../thunks/durationThunk';

const durationSlice = createSlice({
    name: 'duration',
    initialState: {
        isLoading: true,
        error: null,
        durations: [],
        durationLabels: {},
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDuration.fulfilled, (state, action) => {
                state.error = null;
                state.isLoading = false;
                state.durations = action.payload.durations;
                state.durations.map((duration) => {
                    state.durationLabels[duration.duration] = duration.name;
                });
            })
            .addCase(getDuration.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getDuration.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const selectDurationOptions = () =>
    createSelector(
        (state) => state.duration,
        (duration) => {
            let durationOptions = duration.durations.map((duration) => {
                return { label: duration.name, value: duration.duration };
            });
            return durationOptions;
        }
    );

export const { actions } = durationSlice;
export default durationSlice.reducer;
